import React, { Suspense, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Loader from 'src/components/Loader';
import Layout from 'src/components/Layout';

const SignIn = lazy(() => import('src/pages/sign-in'));
const SendMeLink = lazy(() => import('src/pages/send-me-link'));

export default function Routes() {
  return (
    <Suspense fallback={<Loader type="page" />}>
      <Layout>
        <Switch>
          <Route path="/" component={SignIn} exact />
          <Route path="/send-me-link" component={SendMeLink} />
          <Redirect to="/" />
        </Switch>
      </Layout>
    </Suspense>
  );
}
